import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopArticleCategoryByUidApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        slug: z.string(),
        name: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
        addictionalDescription: z.any().optional().nullable(),
    }),
});

type GetSweetShopArticleCategoryByUidActionResponse
    = ApiResponse<z.infer<typeof GetSweetShopArticleCategoryByUidApiResponseSchema>>
    | BaseError;

type GetSweetShopArticleCategoryByUidActionRequest = {
    uid: string,
}

export const getSweetShopArticleCategoryByUid = createAsyncThunk<
    GetSweetShopArticleCategoryByUidActionResponse,
    GetSweetShopArticleCategoryByUidActionRequest
>(
    'SweetShopArticlesPageActionsGetSweetShopArticleCategoryByUid',
    async ({
        uid,
    }) => apiInstance.get(
        `/s/sweet-shop-article-categories/${uid}`,
        {
            'populate[image][fields][0]': 'url',
        },
        GetSweetShopArticleCategoryByUidApiResponseSchema,
    ),
);
